/* eslint-disable react/jsx-no-bind */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import * as R from "constants/userRights";
import PrivateRoute from "../components/routing/PrivateRoute";
import Dashboard from "features/dashboard/Dashboard";
import SettingsContainer from "features/settings/components/SettingsContainer";
import Quotes from "features/quotes/components/QuoteList";
import { Forbidden } from "@totalsoft/rocket-webapp-components-deprecated";
import { AUTH } from "providers/AuthenticationProvider";
import MyProfileContainer from "features/user/components/MyProfileContainer";
import ClientStepContainer from "features/client/components/ClientStepContainer";
import AssetsStepContainer from "features/assets/components/AssetsStepContainer";
import ProductsContainer from "features/products/components/ProductsContainer";
import CompletionData from "features/dataCompletion/components/CompletionData";
import QuoteRouteRedirect from "features/quote/components/QuoteRouteRedirect";
import ContractStepContainer from "features/contractStep/components/ContractStepContainer";
import QuoteDefaultRoute from "features/quote/components/QuoteDefaultRoute";
import Translation from "features/settings/components/TranslationContainer";

const ClientRedirectWrapper = () => <QuoteRouteRedirect DefaultComponent={ClientStepContainer} />;
const AssetsRedirectWrapper = () => <QuoteRouteRedirect DefaultComponent={AssetsStepContainer} />;
const ProductsRedirectWrapper = () => <QuoteRouteRedirect DefaultComponent={ProductsContainer} />;
const CompletionRedirectWrapper = () => <QuoteRouteRedirect DefaultComponent={CompletionData} />;
const ContractRedirectWrapper = () => <QuoteRouteRedirect DefaultComponent={ContractStepContainer} />;

export default function AppRoutes() {
  return (
    <Switch>
      <PrivateRoute exact path="/my-profile" component={MyProfileContainer} routeRights={R.userRights.all} />
      <PrivateRoute exact path="/dashboard" component={Dashboard} />
      <PrivateRoute exact path="/overview" component={Quotes} routeRights={R.userRights.all} />
      <PrivateRoute exact path="/quotes/new/client" component={ClientStepContainer} routeRights={R.userRights.all} />
      <PrivateRoute exact path="/quotes/new/assets" component={AssetsStepContainer} routeRights={R.userRights.all} />
      <PrivateRoute exact path="/quotes/:quoteId(\d+)" component={QuoteDefaultRoute} routeRights={R.userRights.all} />
      <PrivateRoute
        exact
        path="/quotes/:quoteId(\d+)/client"
        component={ClientRedirectWrapper}
        routeRights={R.userRights.all}
      />
      <PrivateRoute
        exact
        path="/quotes/:quoteId(\d+)/assets"
        component={AssetsRedirectWrapper}
        routeRights={R.userRights.all}
      />
      <PrivateRoute
        exact
        path="/quotes/:quoteId(\d+)/products"
        component={ProductsRedirectWrapper}
        routeRights={R.userRights.all}
      />
      <PrivateRoute
        exact
        path="/quotes/:quoteId(\d+)/datacompletion"
        component={CompletionRedirectWrapper}
        routeRights={R.userRights.all}
      />
      <PrivateRoute
        exact
        path="/quotes/:quoteId(\d+)/contract"
        component={ContractRedirectWrapper}
        routeRights={R.userRights.all}
      />
      <PrivateRoute
        exact
        path="/estimations/new/assets"
        component={AssetsStepContainer}
        routeRights={R.userRights.all}
      />
      <PrivateRoute exact path="/settings" component={SettingsContainer} routeRights={[R.userRights.adminUser.code]} />
      <PrivateRoute
        exact
        path="/settings/translations/:languageCode"
        component={Translation}
        routeRights={[R.userRights.adminUser.code]}
      />
      <Redirect exact from="/login" to="/" />
      <Redirect exact from="/" to="/overview" />
      <Redirect exact from={`${AUTH.LOGOUT_REDIRECT}`} to="/overview" />
      <Route exact path="/forbidden" component={Forbidden} />
      <Redirect exact to="/overview" />
    </Switch>
  );
}
